import { FC } from 'react';
import s from './stats.module.scss';
import { toy } from '@specs/specs';
import moment from 'moment/moment';
import { useTranslation } from '@hooks/useTranslation';
import { formatWithSpaces } from '@specs/helpers';
import { StatsItem } from '@components/Cards/StatsItem/StatsItem';
import { useGetToy } from '@hooks/TRPC_Hooks/useGetToy';
import { getToyCollectedCount } from '@helpers/arToysHelpers';
interface Props {
  toyId: toy['id'];
}
export const Stats: FC<Props> = ({
  toyId
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: toy,
    isLoading: isLoadingToy
  } = useGetToy({
    id: toyId
  });
  const collected = toy ? getToyCollectedCount(toy) : 0;
  const burned = toy?.burned ?? 0;
  return <div className={s.stats} data-sentry-component="Stats" data-sentry-source-file="Stats.tsx">
            <StatsItem value={moment(toy?.publishdate).format('DD.MM.YYYY')} text={tr({
      id: 'toy.page.stats.release'
    })} isLoading={isLoadingToy} data-sentry-element="StatsItem" data-sentry-source-file="Stats.tsx" />
            <StatsItem value={formatWithSpaces(collected)} text={tr({
      id: 'toy.page.stats.collected'
    })} isLoading={isLoadingToy} data-sentry-element="StatsItem" data-sentry-source-file="Stats.tsx" />
            <StatsItem value={formatWithSpaces(burned)} text={tr({
      id: 'toy.page.stats.burned'
    })} isLoading={isLoadingToy} data-sentry-element="StatsItem" data-sentry-source-file="Stats.tsx" />
        </div>;
};